import { render } from "./PosAssignStaff.vue?vue&type=template&id=79d57a8e"
import script from "./PosAssignStaff.vue?vue&type=script&lang=js"
export * from "./PosAssignStaff.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__